module.exports = __webpack_public_path__ + "img/图片2.ea1123a0.png";